import "date-fns";
import "date-fns-tz";
import { s as u } from "./Logger-51340717.mjs";
import { u as L } from "./ConfigService-a05d127e.mjs";
const R = function(e, o) {
  let r = {};
  if (e)
    if (e.PageConfigService)
      ({ PageConfigService: r } = e);
    else
      return e.PageConfigService = r, o(r);
  return r;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let o = {};
    const r = () => o, E = (t) => {
      o = Object.assign(o, t);
    };
    return e.getPageConfigs = r, e.setPageConfigs = E, e;
  }
);
var d = /* @__PURE__ */ ((e) => (e.CURRENCY = "currency", e.DECIMAL = "decimal", e))(d || {}), m = /* @__PURE__ */ ((e) => (e.SHORT_DATE = "SHORT_DATE", e.MEDIUM_DATE = "MEDIUM_DATE", e.LONG_DATE = "LONG_DATE", e.FULL_DATE = "FULL_DATE", e))(m || {}), c = /* @__PURE__ */ ((e) => (e.SHORT_TIME = "SHORT_TIME", e.MEDIUM_TIME = "MEDIUM_TIME", e.LONG_TIME = "LONG_TIME", e.FULL_TIME = "FULL_TIME", e))(c || {}), T = /* @__PURE__ */ ((e) => (e.DATE_ONLY = "DATE_ONLY", e.TIME_ONLY = "TIME_ONLY", e.DATE_AND_TIME = "DATE_AND_TIME", e))(T || {});
const a = {
  SHORT_DATE: {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  },
  SHORT_TIME: { hour: "2-digit", minute: "2-digit" },
  MEDIUM_DATE: {
    day: "2-digit",
    month: "short",
    year: "numeric"
  },
  MEDIUM_TIME: {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  },
  LONG_DATE: {
    day: "2-digit",
    month: "long",
    year: "numeric"
  },
  LONG_TIME: {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short"
  },
  FULL_DATE: {
    day: "2-digit",
    month: "long",
    year: "numeric",
    weekday: "long"
  },
  FULL_TIME: {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "long"
  }
};
var s = /* @__PURE__ */ ((e) => (e.BEFORE_PRICE = "before_price", e.AFTER_PRICE = "after_price", e))(s || {}), N = /* @__PURE__ */ ((e) => (e.SYMBOL = "symbol", e.CODE = "code", e))(N || {});
const D = "GMT", { locale: C } = u.getPreferences(), h = C || "en", p = (e, o = null) => {
  const { locale: r, currency: E, currencyFormatConfig: t } = u.getPreferences(), n = o || E;
  let i = "";
  return t && n in t ? i = S(e, t[n]) : (i = new Intl.NumberFormat(r || "th", {
    style: n ? d.CURRENCY : d.DECIMAL,
    ...n && { currency: n }
  }).format(e), i = i.replace(/ /g, " "), i.match(/^(\D)(\d)/gm) && (i = i.replace(i[0], `${i[0]} `))), i;
}, g = (e, o) => Number(e) >= 1e3 ? e.indexOf(".") > -1 ? `${g(e.slice(0, e.indexOf(".") - 3), o)}${o ?? ","}${e.slice(e.indexOf(".") - 3)}` : `${g(e.slice(0, -3), o)}${o ?? ","}${e.slice(-3)}` : e, $ = (e, o) => o === "CEIL" ? `${Math.ceil(Number(e))}` : o === "FLOOR" ? `${Math.floor(Number(e))}` : o === "ROUND" ? `${Math.round(Number(e))}` : e, S = (e, o) => {
  const r = L.getConfigs(), E = R.getPageConfigs();
  let t = e.toString();
  E != null && E.priceFormat && (t = $(t, E == null ? void 0 : E.priceFormat)), t = Number(t).toFixed(
    r.REMOVE_PRICE_TRAILING_ZEROS && Number.isInteger(Number(t)) ? 0 : o.decimals
  ), o != null && o.roundOff && (t = `${Math.round(Number(t))}.00`), t = g(t, o.thousandSeparator);
  const n = [...t], i = n.lastIndexOf(".");
  return i !== -1 && n.splice(i, 1, o.decimalSeparator), t = n.join(""), o.showSymbolOrCode === N.SYMBOL ? t = o.symbolPosition === s.BEFORE_PRICE ? `${o.symbol} ${t}` : `${t} ${o.symbol}` : t = o.codePosition === s.BEFORE_PRICE ? `${o.code} ${t}` : `${t} ${o.code}`, t;
}, U = (e, o, r) => f(e, { date: o }, void 0, void 0, r, T.DATE_ONLY), H = (e, o, r, E, t, n = T.DATE_AND_TIME) => f(e, o, r, E, t, n), f = (e, o, r, E, t, n = T.DATE_AND_TIME) => {
  const i = e ? new Date(e) : /* @__PURE__ */ new Date(), I = L.getConfigs(), { locale: A } = u.getPreferences(), _ = E ?? I.NEXT_PUBLIC_TIMEZONE, l = t ?? (A || I.NEXT_PUBLIC_LOCALE) ?? h, O = (o == null ? void 0 : o.date) ?? m.SHORT_DATE, M = (o == null ? void 0 : o.time) ?? c.SHORT_TIME;
  switch (n) {
    case T.DATE_ONLY:
      return Intl.DateTimeFormat(l, {
        ...a[O || m.SHORT_DATE],
        timeZone: _ || Intl.DateTimeFormat().resolvedOptions().timeZone
      }).format(i);
    case T.TIME_ONLY:
      return Intl.DateTimeFormat(l, {
        ...a[M || c.SHORT_TIME],
        timeZone: _ || D,
        hour12: r ?? !0
      }).format(i);
    default:
      return Intl.DateTimeFormat(l, {
        ...a[O || m.SHORT_DATE],
        ...a[M || c.SHORT_TIME],
        timeZone: _ || D,
        hour12: r ?? !0
      }).format(i);
  }
};
export {
  U as E,
  T as M,
  m as T,
  p as X,
  H as q
};
//# sourceMappingURL=I18nUtils-f6d3f613.mjs.map
